<ng-template #countryGroupModalFormContent role="document" let-modal>

  <app-page-comp-header #pageHeader
    [showBottomBorder]="false"
    [title]="formTitle"
  >
  </app-page-comp-header>

  <form (ngSubmit)="countryGroupFormSubmitAttempt()" [formGroup]="countryGroupForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body cg-modal-body" id="countryGroupFormDetails">

      <!-- Group name -->
      <div class="cg-form-group">
        <label class="cg-label" for="groupName-field">Group Name</label>
        <input autocomplete="no-fill" data-lpignore="true" type="text" id="groupName-field" class="cg-input"
               placeholder="e.g. European Roaming, APAC Region" formControlName="groupName" [readonly]="readOnly"
               [ngClass]="{ 'is-invalid': formSubmitted && formOfCountryGroupAdd['groupName'].errors }" />
        @if(formSubmitted && formOfCountryGroupAdd['groupName'].hasError('maxlength')) {
          <div class="cg-error">Maximum length of {{nameMaxLength}} characters has been exceeded</div>
        } @else if(formSubmitted && formOfCountryGroupAdd['groupName'].errors) {
          <div class="cg-error">A value is required</div>
        }
      </div>

      <!-- Visibility (Utelize users only) -->
      @if(isUtelize && !readOnly) {
        <div class="cg-form-group">
          <label class="cg-label">Visibility</label>
          <div class="cg-vis-options">
            <div class="cg-vis-card" [class.active]="!allCustomersValue" (click)="setVisibility(false)">
              <div class="cg-vis-title"><span class="cg-vis-dot"></span> Selected customer</div>
              <div class="cg-vis-desc">Only the chosen customer can see and use this group.</div>
            </div>
            <div class="cg-vis-card" [class.active]="allCustomersValue" (click)="setVisibility(true)">
              <div class="cg-vis-title"><span class="cg-vis-dot"></span> All customers</div>
              <div class="cg-vis-desc">A shared, curated group (e.g. Premium Zone) visible to everyone.</div>
            </div>
          </div>
          <div class="cg-helper">Customer administrators don't see this — their groups are always private to their own organisation.</div>
        </div>

        @if(!allCustomersValue) {
          <div class="cg-form-group">
            <label class="cg-label" for="companyId-field">Customer</label>
            <select id="companyId-field" class="cg-input" formControlName="companyId"
                    [ngClass]="{ 'is-invalid': formSubmitted && !formOfCountryGroupAdd['companyId'].value }">
              <option [ngValue]="null">Select a customer...</option>
              @for(company of companyList; track company.id) {
                <option [ngValue]="company.id">{{company.description}}</option>
              }
            </select>
            @if(formSubmitted && !formOfCountryGroupAdd['companyId'].value) {
              <div class="cg-error">Please select a customer</div>
            }
          </div>
        }
      }

      <!-- Countries -->
      <div class="cg-form-group">
        <label class="cg-label">Countries</label>
        <div class="cg-country-selection">
          <div class="cg-country-search">
            <input type="text" [(ngModel)]="countrySearch" [ngModelOptions]="{ standalone: true }" placeholder="Search countries..." />
          </div>
          @if(!readOnly) {
            <div class="cg-selection-actions">
              <button type="button" class="cg-action-btn" [disabled]="allFilteredSelected" (click)="selectAllCountries()">Select all</button>
              <button type="button" class="cg-action-btn" [disabled]="selected.size === 0" (click)="clearAllCountries()">Clear all</button>
            </div>
          }
          <div class="cg-country-list">
            @for(c of filteredCountries; track c.countryId) {
              <div class="cg-country-item" [class.selected]="isSelected(c)" [class.readonly]="readOnly" (click)="toggleCountry(c)">
                <div class="cg-checkbox"></div>
                <span class="cg-country-name">{{ c.countryName }}</span>
              </div>
            } @empty {
              <div class="cg-country-empty">No countries match your search.</div>
            }
          </div>
          <div class="cg-selected-count"><strong>{{ selected.size }}</strong> {{ selected.size === 1 ? 'country' : 'countries' }} selected</div>
        </div>
        @if(formSubmitted && selected.size === 0) {
          <div class="cg-error">Select at least one country</div>
        }
      </div>

    </div>

    <div class="modal-footer">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="countryGroupFormCancel()">Close</button>
              @if(!readOnly) {
                <button type="submit" class="btn btn-success" id="add-btn-countryGroup-edit" [disabled]="!canSubmit">Submit</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>

</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="countryGroupCompletedModalHasBeenClosed()"
></app-completed-modal-form>
